export default __webpack_public_path__ + "static/media/cctv1.de1af719.svg";